export default "__VITE_ASSET__CooTFFDu__"